import {
  Col,
  Divider,
  Row,
  Space,
  Spin,
  Table,
  Tag,
  Typography,
  Modal,
  Tabs,
  Rate,
  Button,
  Badge,
} from 'antd';
import Link from 'antd/lib/typography/Link';
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useQueryParam } from 'use-query-params';
import { FlexBox } from '../../../../components/atoms/FlexBox';
import { CycleToggle } from '../../../../components/atoms/ItemToggle';
import { UserAvatar } from '../../../../components/atoms/UserAvatar';
import ReviewPreview from '../../../../components/molecules/ReviewPreview/ReviewPreview';
import { useConnection, useUserInfo } from '../../../../connection/Application';
import { PerformanceCycle } from '../../../../entity/PerformanceCycle';
import { WebUxPage, WebUxPageContent, WebUxPageItem } from '../../webux-layouts/WebUxPage';
import {
  AlignLeftOutlined,
  ArrowRightOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
  ExclamationCircleOutlined,
  RetweetOutlined,
  StarFilled,
} from '@ant-design/icons';
import { Criteria } from '../review-settings/reviewQuestions';
import { RichText } from '../../../../components/RichText/RichText';
import ReactHtmlParser from '../../../../utils/SafeHtmlParser';
import { PageHeader } from '@ant-design/pro-layout';
import dayjs from 'dayjs';
const { confirm } = Modal;
const { Title, Text } = Typography;
const { TabPane } = Tabs;

export interface PeerReviewModel {
  criteriaSet?: Criteria[];
  overallComment?: string;
  submitTime?: string;
  cycle?: number | null;
  submittingUser?: number;
  peerReviewType?: boolean;
}

const regex = /(<([^>]+)>)/gi;

const PeerReviews: FC = () => {
  const [cycle, setCycle] = useQueryParam<number | undefined>('cycle');
  const cycleRef = useRef(cycle);
  const user = useUserInfo();
  const [cycles, setCycles] = useState<PerformanceCycle[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loading1, setLoading1] = useState<boolean>(false);
  const [fetching, setFetching] = useState<boolean>(false);
  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [record1, setRecord1] = useState<undefined | any>(undefined);
  const connection = useConnection();
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [showContent, setShowContent] = useState<boolean>(true);
  const [submitData, setSubmitData] = useState<PeerReviewModel>({
    criteriaSet: [],
    overallComment: '',
    submitTime: '',
    cycle: cycle,
    submittingUser: 0,
    peerReviewType: true,
  });
  // const events = useEvents();

  const columns = useMemo(() => {
    return [
      {
        title: 'Peer Name',
        dataIndex: 'peerName',
        key: 'peerName',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            <UserAvatar type={'user'} src={record.peerImage} />
            <Link
              onClick={() => {
                window.onbeforeunload = function () {
                  return 'Data will be lost if you leave the page, are you sure?';
                };
                setModalVisible(true);
                setRecord1(record);
                setSubmitData({
                  criteriaSet: record?.criteriaSet?.criterias,
                  overallComment: record?.overallComment ?? '',
                  submitTime: '',
                  cycle: cycle,
                  submittingUser: 0,
                  peerReviewType: record?.peerReviewType ?? true,
                });
              }}>
              {text}
            </Link>
          </Space>
        ),
      },
      {
        title: 'Team',
        dataIndex: 'teamName',
        key: 'teamName',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            <UserAvatar type={'team'} src={record.teamImage} />
            <Typography>{text}</Typography>
          </Space>
        ),
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            {(record.status == '' || record.status == 'not submitted') && (
              <Tag color={'blue'}>Not submitted</Tag>
            )}
            {record.status == 'drafted' && <Tag>Drafted</Tag>}
            {record.status == 'submitted' && <Tag color={'yellow'}>Submitted</Tag>}
            {record.status == 'rejected' && <Tag color={'red'}>Rejected</Tag>}
            {record.status == 'approved' && <Tag color={'green'}>Approved</Tag>}
          </Space>
        ),
      },
      {
        title: 'Score',
        dataIndex: 'marks',
        key: 'marks',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => (
          <Space>
            {!(record.status == '' || record.status == 'not submitted') && (
              <Badge
                count={
                  record.criteriaSet.criterias.reduce(
                    (x: any, y: any) => x + (y.answer / y.type) * 100,
                    0,
                  ) /
                    record.criteriaSet.criterias.length +
                  '%'
                }
                showZero
                overflowCount={120}
                style={{ fontSize: '16px' }}
                color={
                  record.criteriaSet.criterias.reduce(
                    (x: any, y: any) => x + (y.answer / y.type) * 100,
                    0,
                  ) /
                    record.criteriaSet.criterias.length >
                  85
                    ? '#52c41a'
                    : record.criteriaSet.criterias.reduce(
                        (x: any, y: any) => x + (y.answer / y.type) * 100,
                        0,
                      ) /
                        record.criteriaSet.criterias.length >
                      60
                    ? '#faad14'
                    : ''
                }
              />
              // <Progress
              //   type="circle"
              //   percent={
              //     record.criteriaSet.criterias.reduce(
              //       (x: any, y: any) => x + (y.answer / y.type) * 100,
              //       0,
              //     ) / record.criteriaSet.criterias.length
              //   }
              //   format={() =>
              //     `${
              //       record.criteriaSet.criterias.reduce(
              //         (x: any, y: any) => x + (y.answer / y.type) * 100,
              //         0,
              //       ) / record.criteriaSet.criterias.length
              //     }%`
              //   }
              //   width={65}
              // />
            )}
          </Space>
        ),
      },
    ];
  }, [cycle]);

  useEffect(() => {
    const token = connection.hasSession();
    if (token) {
      setLoading(true);
      connection
        .get<{ performanceCycle: PerformanceCycle[]; closestCycle: PerformanceCycle }>('cycles')
        .then((value) => {
          setCycles(value.performanceCycle);
          if (cycleRef.current === undefined) {
            setCycle(value.closestCycle.id, 'replace');
          }
        })
        .catch(() => setLoading(false));
    }
  }, [connection, setCycle]);

  useEffect(() => {
    setLoading(true);
    if (cycle) {
      connection
        .get(`goals/review/user/${cycle}`)
        .then((users: any) => {
          setTableData(users.reviewingUsers);
          setTableData1(users.reviewForMe);
        })
        .finally(() => setLoading(false));
    }
  }, [connection, cycle, fetching]);

  const draftPeerReview = useCallback(() => {
    setLoading1(true);
    connection
      .patch(`goals/peer_review/answer/draft/${record1.id}`, {
        answers: submitData?.criteriaSet?.map((e) => ({
          id: e.id,
          answer: ((e?.answer ?? 0) !== 0 ? (e?.answer ?? 0) / e?.type : 0) * 100,
          comment: e?.comment ?? '',
        })),
        overallComment: submitData?.overallComment ?? '',
        peerReviewType: submitData?.peerReviewType ?? true,
      })
      .then(() => {
        window.onbeforeunload = null;
        setModalVisible(false);
        setSubmitData({
          criteriaSet: [],
          overallComment: '',
          submitTime: '',
          cycle: cycle,
          submittingUser: 0,
          peerReviewType: true,
        });
        setFetching(!fetching);
        setRecord1(undefined);
      })
      .finally(() => setLoading1(false));
  }, [
    connection,
    cycle,
    fetching,
    record1?.id,
    submitData?.criteriaSet,
    submitData?.overallComment,
    submitData?.peerReviewType,
  ]);

  const createPeerReview = useCallback(() => {
    setLoading1(true);
    if (submitData?.criteriaSet?.length !== 0) {
      connection
        .patch(`goals/peer_review/answer/${record1.id}`, {
          answers: submitData?.criteriaSet?.map((e) => ({
            id: e.id,
            answer: ((e.answer ?? 0) / e.type) * 100,
            comment: e.comment,
          })),
          overallComment: submitData?.overallComment,
          peerReviewType: submitData?.peerReviewType ?? true,
        })
        .then(() => {
          window.onbeforeunload = null;
          setModalVisible(false);
          setSubmitData({
            criteriaSet: [],
            overallComment: '',
            submitTime: '',
            cycle: cycle,
            submittingUser: 0,
            peerReviewType: true,
          });
          setFetching(!fetching);
          setRecord1(undefined);
        })
        .finally(() => setLoading1(false));
    }
  }, [
    connection,
    cycle,
    fetching,
    record1?.id,
    submitData?.criteriaSet,
    submitData?.overallComment,
    submitData?.peerReviewType,
  ]);

  const showApproveModal = useCallback(() => {
    confirm({
      title: 'Submitting your review',
      icon: <ExclamationCircleOutlined />,
      content: `If you submit you won't be able to change`,
      okText: `Submit`,
      centered: true,
      okType: 'primary',
      cancelText: 'Cancel',
      onOk() {
        setSubmitData({
          ...submitData,
          cycle: cycle,
          submittingUser: user?.userId,
          submitTime: dayjs().format('MMM DD, YYYY h:mm a'),
        });
        createPeerReview();
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }, [createPeerReview, cycle, submitData, user?.userId]);

  const showDraftModal = useCallback(() => {
    confirm({
      title: 'Draft your review',
      icon: <ExclamationCircleOutlined />,
      content: `Draft your review changes`,
      okText: `Draft`,
      centered: true,
      okType: 'primary',
      cancelText: 'Cancel',
      onOk() {
        setSubmitData({
          ...submitData,
          cycle: cycle,
          submittingUser: user?.userId,
          submitTime: dayjs().format('MMM DD, YYYY h:mm a'),
        });
        draftPeerReview();
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }, [cycle, draftPeerReview, submitData, user?.userId]);

  return (
    <WebUxPage>
      <PageHeader
        ghost={false}
        style={{ background: '#FFF' }}
        title="Peer / Subordinate Reviews"
        subTitle="Manage my peer / Subordinate reviews"
        // breadcrumb={{
        //   routes: [
        //     {
        //       path: 'goals',
        //       breadcrumbName: `Peer / Subordinate Reviews`,
        //     },
        //   ],
        // }}
      />
      <WebUxPageContent>
        <WebUxPageItem>
          <FlexBox>
            <CycleToggle
              value={parseInt(`${cycle}`)}
              onChange={(value) => setCycle(value, 'replace')}
              data={cycles}
            />
          </FlexBox>
          <Spin spinning={loading}>
            <Tabs defaultActiveKey="1">
              <TabPane tab="Reviews By Me" key="1">
                <Table
                  size="small"
                  columns={columns}
                  dataSource={tableData}
                  expandable={{ indentSize: 0 }}
                  pagination={false}
                />
              </TabPane>
              <TabPane tab="Reviews For Me" key="2">
                <Table
                  size="small"
                  columns={columns}
                  dataSource={tableData1}
                  expandable={{ indentSize: 0 }}
                  pagination={false}
                />
              </TabPane>
            </Tabs>
          </Spin>
        </WebUxPageItem>
      </WebUxPageContent>
      <Modal
        destroyOnClose={true}
        open={modalVisible}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setRecord1(undefined);
              setSubmitData({
                criteriaSet: [],
                overallComment: '',
                submitTime: '',
                cycle: cycle,
                submittingUser: 0,
                peerReviewType: true,
              });
              window.onbeforeunload = null;
              setModalVisible(false);
              // events.emit('PEER_REVIEW_CLOSE');
            }}>
            Cancel
          </Button>,
          <Button
            key="draft"
            hidden={record1?.mode === 'view' || record1?.status === 'rejected'}
            type="default"
            loading={loading1}
            onClick={() => showDraftModal()}>
            Draft
          </Button>,
          <Button
            key="submit"
            hidden={record1?.mode === 'view'}
            disabled={
              submitData?.overallComment === '<p><br></p>' ||
              submitData?.overallComment === '' ||
              submitData?.criteriaSet?.length === 0 ||
              submitData?.criteriaSet?.findIndex(
                (e) => e.answer === 0 || e.answer === null || e.answer === undefined,
              ) !== -1
            }
            type="primary"
            loading={loading1}
            onClick={() => showApproveModal()}>
            Submit
          </Button>,
        ]}
        onCancel={() => {
          setRecord1(undefined);
          setSubmitData({
            criteriaSet: [],
            overallComment: '',
            submitTime: '',
            cycle: cycle,
            submittingUser: 0,
            peerReviewType: true,
          });
          window.onbeforeunload = null;
          setModalVisible(false);
          // events.emit('PEER_REVIEW_CLOSE');
        }}
        okText={'Submit'}
        okButtonProps={{
          hidden: record1?.mode === 'view',
          disabled:
            submitData?.overallComment === '<p><br></p>' ||
            submitData?.overallComment === '' ||
            submitData?.criteriaSet?.length === 0 ||
            submitData?.criteriaSet?.findIndex(
              (e) => e.answer === 0 || e.answer === null || e.answer === undefined,
            ) !== -1,
        }}
        onOk={() => showApproveModal()}>
        <Row style={{ marginTop: '3%' }}>
          <UserAvatar src={record1?.peerImage ?? null} size={80} />
          <Col style={{ marginLeft: '3%' }}>
            <Title level={3} style={{ margin: 0 }}>
              {record1?.peerName}
            </Title>
            <Text type="secondary">{record1?.peerDesignation}</Text>
            <div>
              <Tag color="blue">{record1?.teamName}</Tag>
            </div>
          </Col>
        </Row>
        <Divider style={{ marginTop: '2%' }} />
        <div style={{ marginLeft: '1%' }}>
          <ReviewPreview
            mode={record1?.mode}
            criterias={record1?.criteriaSet?.criterias}
            onChange={(val) => setSubmitData({ ...submitData, criteriaSet: val })}
          />
        </div>
        <Space style={{ marginTop: '2%' }}>
          <StarFilled style={{ color: 'red', fontSize: 7, paddingRight: 5 }} />
          <AlignLeftOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
          <Text type="secondary">Overall Comment</Text>
        </Space>
        <Divider orientation="left" style={{ marginTop: 0, marginBottom: 0 }} />
        <div style={{ marginTop: '2%' }}>
          {record1?.mode === 'edit' && (
            // <TextArea
            //   placeholder="Add your overall comment"
            //   allowClear
            //   autoSize={{ minRows: 3, maxRows: 5 }}
            //   value={submitData?.overallComment}
            //   onChange={(e) => setSubmitData({ ...submitData, overallComment: e.target.value })}
            // />
            <RichText
              placeholder={'Add your overall comment'}
              value={submitData?.overallComment}
              maxLength={10000}
              onChange={(e) => setSubmitData({ ...submitData, overallComment: e })}
            />
          )}
          {record1?.mode === 'view' && (
            <Typography>
              {record1?.overallComment && !!record1?.overallComment?.replace(regex, '').length
                ? ReactHtmlParser(record1?.overallComment)
                : ''}
            </Typography>
          )}
        </div>
        <Divider orientation="left" style={{ marginTop: 0, marginBottom: 0 }} />
        {((record1?.mode === 'edit' && record1?.status === 'rejected') ||
          record1?.mode === 'view') &&
          record1?.peerReviewHistory?.length !== 0 &&
          record1?.peerReviewHistory !== undefined && (
            <>
              <Row style={{ alignItems: 'center', marginTop: 20 }}>
                <Space>
                  <Title level={5}>Activity</Title>
                  <RetweetOutlined style={{ fontSize: 20 }} />
                </Space>
              </Row>
              <Link onClick={() => setShowContent(!showContent)}>
                <Space className="div_hover">
                  <Text>Show Activities</Text>
                  {!showContent ? (
                    <CaretDownOutlined style={{ marginTop: 7, color: 'rgba(0,0,0,0.7)' }} />
                  ) : (
                    <CaretUpOutlined style={{ marginTop: 7, color: 'rgba(0,0,0,0.7)' }} />
                  )}
                </Space>
              </Link>
            </>
          )}
        {record1?.mode === 'view' &&
          record1?.peerReviewHistory !== undefined &&
          record1?.peerReviewHistory?.length !== 0 &&
          showContent &&
          record1?.peerReviewHistory?.map((item: any, key: any) => {
            return (
              <div key={key} className="borderBox">
                <Row>
                  <Space>
                    <UserAvatar src={item?.image} />
                    <Text strong>{item?.name}</Text>
                    <Text type="secondary">{item.date}</Text>
                  </Space>
                </Row>
                <Row>
                  <Text strong>
                    Status:
                    {(record1.status == '' || record1.status == 'not submitted') && (
                      <Tag color={'blue'}>Not submitted</Tag>
                    )}
                    {item.status == 'drafted' && <Tag>Drafted</Tag>}
                    {item.status == 'submitted' && <Tag color={'yellow'}>Submitted</Tag>}
                    {item.status == 'rejected' && <Tag color={'red'}>Rejected</Tag>}
                    {item.status == 'approved' && <Tag color={'green'}>Approved</Tag>}
                  </Text>
                </Row>
                {item?.status === 'submitted' &&
                  item.history?.map((e: any, index1: any) => {
                    return (
                      <div key={index1}>
                        <Row style={{ marginTop: 20 }}>
                          <Text type="secondary">{`Submitted ${e.criteriaName}`}</Text>
                        </Row>
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Answer</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Rate
                                value={(e.newAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                            </Row>
                          </div>
                        )}
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                        {e.newAnswer === 0 && e.oldAnswer === 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                      </div>
                    );
                  })}
                {item?.status !== 'submitted' &&
                  item.history?.map((e: any, index1: any) => {
                    return (
                      <div key={index1}>
                        <Row style={{ marginTop: 10 }}>
                          <Text type="secondary">{`Updated ${e.criteriaName}`}</Text>
                        </Row>
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Answer</Text>
                            </Row>
                            <Row style={{ marginLeft: 20, display: 'flex', alignItems: 'center' }}>
                              <Rate
                                value={(e.oldAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                              <ArrowRightOutlined
                                style={{ paddingTop: 6, paddingLeft: 15, paddingRight: 15 }}
                              />
                              <Rate
                                value={(e.newAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                            </Row>
                          </div>
                        )}
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>

                            <Row style={{ marginLeft: 20, display: 'flex', alignItems: 'center' }}>
                              <Text type="secondary">
                                {e.oldComment && !!e.oldComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.oldComment)
                                  : ''}
                              </Text>
                              <ArrowRightOutlined style={{ paddingLeft: 15, paddingRight: 15 }} />
                              <Text type="secondary">
                                {'   '}
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                        {e.newAnswer === 0 && e.oldAnswer === 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.oldComment && !!e.oldComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.oldComment)
                                  : ''}
                                {'   '}
                              </Text>
                              <ArrowRightOutlined style={{ paddingLeft: 15, paddingRight: 15 }} />
                              <Text type="secondary">
                                {'   '}
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            );
          })}
        {record1?.mode === 'edit' &&
          record1?.status === 'rejected' &&
          record1?.peerReviewHistory !== undefined &&
          record1?.peerReviewHistory?.length !== 0 &&
          showContent &&
          record1?.peerReviewHistory?.map((item: any, key: any) => {
            return (
              <div key={key} className="borderBox">
                <Row>
                  <Space>
                    <UserAvatar src={item?.image} />
                    <Text strong>{item?.name}</Text>
                    <Text type="secondary">{item.date}</Text>
                  </Space>
                </Row>
                <Row>
                  <Text strong>
                    Status:
                    {(record1.status == '' || record1.status == 'not submitted') && (
                      <Tag color={'blue'}>Not submitted</Tag>
                    )}
                    {item.status == 'drafted' && <Tag>Drafted</Tag>}
                    {item.status == 'submitted' && <Tag color={'yellow'}>Submitted</Tag>}
                    {item.status == 'rejected' && <Tag color={'red'}>Rejected</Tag>}
                    {item.status == 'approved' && <Tag color={'green'}>Approved</Tag>}
                  </Text>
                </Row>
                {item?.status === 'submitted' &&
                  item.history?.map((e: any, index1: any) => {
                    return (
                      <div key={index1}>
                        <Row style={{ marginTop: 20 }}>
                          <Text type="secondary">{`Submitted ${e.criteriaName}`}</Text>
                        </Row>
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Answer</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Rate
                                value={(e.newAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                            </Row>
                          </div>
                        )}
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                        {e.newAnswer === 0 && e.oldAnswer === 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                      </div>
                    );
                  })}
                {item?.status !== 'submitted' &&
                  item.history?.map((e: any, index1: any) => {
                    return (
                      <div key={index1}>
                        <Row style={{ marginTop: 10 }}>
                          <Text type="secondary">{`Updated ${e.criteriaName}`}</Text>
                        </Row>
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Answer</Text>
                            </Row>
                            <Row style={{ marginLeft: 20, display: 'flex', alignItems: 'center' }}>
                              <Rate
                                value={(e.oldAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                              <ArrowRightOutlined
                                style={{ paddingTop: 6, paddingLeft: 15, paddingRight: 15 }}
                              />
                              <Rate
                                value={(e.newAnswer / 100) * e.criteriaType ?? 0}
                                character={<StarFilled style={{ fontSize: 15 }} />}
                                count={e.type}
                                disabled={true}
                              />
                            </Row>
                          </div>
                        )}
                        {e.newAnswer !== 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>

                            <Row style={{ marginLeft: 20, display: 'flex', alignItems: 'center' }}>
                              <Text type="secondary">
                                {e.oldComment && !!e.oldComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.oldComment)
                                  : ''}
                              </Text>
                              <ArrowRightOutlined style={{ paddingLeft: 15, paddingRight: 15 }} />
                              <Text type="secondary">
                                {'   '}
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                        {e.newAnswer === 0 && e.oldAnswer === 0 && (
                          <div>
                            <Row style={{ marginLeft: 20 }}>
                              <Text strong>Comment</Text>
                            </Row>
                            <Row style={{ marginLeft: 20 }}>
                              <Text type="secondary">
                                {e.oldComment && !!e.oldComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.oldComment)
                                  : ''}
                                {'   '}
                              </Text>
                              <ArrowRightOutlined style={{ paddingLeft: 15, paddingRight: 15 }} />
                              <Text type="secondary">
                                {'   '}
                                {e.newComment && !!e.newComment?.replace(regex, '').length
                                  ? ReactHtmlParser(e.newComment)
                                  : ''}
                              </Text>
                            </Row>
                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            );
          })}
      </Modal>
    </WebUxPage>
  );
};

export default PeerReviews;
